import { Component, OnInit } from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'app-anim-popcoverage',
  templateUrl: './anim-popcoverage.component.html',
  styleUrls: ['./anim-popcoverage.component.scss']
})
export class AnimPopcoverageComponent implements OnInit {
  tlPop = gsap.timeline({ repeat: -1, yoyo: true });
  constructor() { }

  ngOnInit(): void {
    this.animate();
  }

  ngOnDestroy(): void{
    this.tlPop.kill();
  }

  animate() {
    // let this.tlPop = gsap.timeline({ repeat: -1, yoyo: true });
    this.tlPop.addLabel('start', 1);
    this.tlPop.add(this.animateCity('.banyuwangi', 1018.71, 295.181), 'start');
    this.tlPop.add(this.animateCity('.jember', 963.166), '>-=0.5');
    this.tlPop.add(this.animateCity('.probolinggo', 907.627, 256.098), '>-=0.5');
    this.tlPop.add(this.animateCity('.pasuruan', 870.601), '>-=0.5');
    this.tlPop.add(this.animateCity('.sidoarjo', 846, 214), '>-=0.5');
    this.tlPop.add(this.animateCity('.pasarturi', 842.803, 192.33), '>-=0.5');
    this.tlPop.add(this.animateCity('.malang', 836.66), '>-=0.5');
    this.tlPop.add(this.animateCity('.kediri', 771.864, 257.126), '>-=0.5');
    this.tlPop.add(this.animateCity('.tulungagung', 762.607), '>-=0.5');
    this.tlPop.add(this.animateCity('.nganjuk', 749.237, 238.613), '>-=0.5');
    this.tlPop.add(this.animateCity('.madiun', 711.183, 240.67), '>-=0.5');
    this.tlPop.add(this.animateCity('.solobalapan', 643.301, 237.585), '>-=0.5');
    this.tlPop.add(this.animateCity('.klaten', 618.617), '>-=0.5');
    this.tlPop.add(this.animateCity('.semarangtawang', 590.539, 169.021), '>-=0.5');
    this.tlPop.add(this.animateCity('.tugujogja', 587.762), '>-=0.5');
    this.tlPop.add(this.animateCity('.kutoarjo', 531.194), '>-=0.5');
    this.tlPop.add(this.animateCity('.pekalongan', 507.539, 167.646), '>-=0.5');
    this.tlPop.add(this.animateCity('.tegal', 435.543, 169.703), '>-=0.5');
    this.tlPop.add(this.animateCity('.cilacap', 430.4), '>-=0.5');
    this.tlPop.add(this.animateCity('.cirebon', 365.605, 142.962), '>-=0.5');
    this.tlPop.add(this.animateCity('.tasikmalaya', 351.206), '>-=0.5');
    this.tlPop.add(this.animateCity('.bandung', 299.781), '>-=0.5');
    this.tlPop.add(this.animateCity('.purwakarta', 260.697, 169.703), '>-=0.5');
    this.tlPop.add(this.animateCity('.cikampek', 248.355, 129.591), '>-=0.5');
    this.tlPop.add(this.animateCity('.sukabumi', 202.073), '>-=0.5');
    this.tlPop.add(this.animateCity('.bogor', 187.674), '>-=0.5');
    this.tlPop.add(this.animateCity('.gambir', 186.646, 97.708), '>-=0.5');
    this.tlPop.add(this.animateCity('.cisauk', 165.047, 113.135), '>-=0.5');
    this.tlPop.add(this.animateCity('.rangkasbitung', 121.335), '>-=0.5');
    this.tlPop.add(this.animateCity('.merak', 101.279, 76.6235), '>-=0.5');
    this.tlPop.to('.banyuwangi .label', { opacity: 0, duration: 1 });
    this.tlPop.totalDuration(5);
  }

  /**
   * @param x city line's x
   * @param y city line's y at circle center
   */
  animateCity(city, x, y = null) {
    let tl = gsap.timeline();
    tl.to(city + ' .name',  { opacity: 0 })
      .to(city + ' .label', { attr: { x, width: 0 } }, '<')
      .to(city + ' .line', { attr: { height: 0 } });
    if (y) {
      tl.to(city + ' .line', { attr: { y } }, '<');
    }
    tl.set(city + ' .circle', { opacity: 0 })

    return tl;
  }
}
